import {gql} from '@apollo/client';

// 获取所有州列表
export const GET_ALL_STATES = gql`
    query getAllStates {
        getAllStates
    }
`;

// 根据州获取城市列表
export const GET_CITIES_BY_STATE = gql`
    query getCitiesByState($state: String!) {
        getCitiesByState(state: $state)
    }
`;

// 根据州和城市获取邮编列表
export const GET_ZIPCODES_BY_STATE_AND_CITY = gql`
    query getZipcodesByStateAndCity($state: String!, $city: String!) {
        getZipcodesByStateAndCity(state: $state, city: $city)
    }
`;

// 根据邮编获取详细信息
export const GET_ZIPCODE_DETAIL = gql`
    query getZipcodeByCode($zipcode: String!) {
        getZipcodeByCode(zipcode: $zipcode) {
            zipcode
            city
            state
            timezone
            county
            latitude
            longitude
        }
    }
`;

export interface ZipcodeType {
    zipcode: string;
    city: string;
    state: string;
    timezone?: string;
    county?: string;
    latitude?: number;
    longitude?: number;
}

export interface GetAllStatesResponse {
    getAllStates: string[];
}

export interface GetCitiesByStateResponse {
    getCitiesByState: string[];
}

export interface GetZipcodesByStateAndCityResponse {
    getZipcodesByStateAndCity: string[];
}

export interface GetZipcodeDetailResponse {
    getZipcodeByCode: ZipcodeType | null;
} 